module.exports = __webpack_public_path__ + "img/broadcast_5.f17ef1e2.png";